export const Logo = ({ size = 40 }) => (
  <svg width={size} height={size} viewBox="0 0 64 64" fill="none" data-testid="cosmic-cloudz-logo">
    <defs>
      <linearGradient id="ccg" x1="0" y1="0" x2="64" y2="64" gradientUnits="userSpaceOnUse">
        <stop stopColor="#FF2A85" />
        <stop offset="0.55" stopColor="#9D4EDD" />
        <stop offset="1" stopColor="#00F0FF" />
      </linearGradient>
    </defs>
    <circle cx="32" cy="32" r="17" stroke="url(#ccg)" strokeWidth="4.5" />
    <path d="M22 30c3-4 7-5 10-3s7 1 10-2" stroke="url(#ccg)" strokeWidth="3" strokeLinecap="round" />
    <path d="M23 37c4 3 9 3 13 1" stroke="#FF65B1" strokeWidth="3" strokeLinecap="round" opacity="0.8" />
    <ellipse cx="32" cy="32" rx="27" ry="9.5" stroke="#FFD166" strokeWidth="2.6" transform="rotate(-20 32 32)" />
    <path d="M46 12l1.6 3.8L51.5 17.5l-3.9 1.7L46 23l-1.6-3.8-3.9-1.7 3.9-1.7L46 12z" fill="#fff" />
  </svg>
);

export default Logo;
